import { FREELANCECLIENTMATCHINGJOBS } from "../../ENVIRONMENT";

// api for freelance candidate details
async function freecandidateDetails(token, id) {
  const response = await fetch(FREELANCECLIENTMATCHINGJOBS + `/${id}`, {
    headers: {
      "Content-Type": "Application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { freecandidateDetails };
